import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';

const Title = ({ values }) => (
  <Content>
    {({
      globalRadioError = '',
      personDetailsTitleHeader = '',
      personDetailsTitleValue1 = '',
      personDetailsTitleValue2 = '',
      personDetailsTitleValue3 = '',
      personDetailsTitleValue4 = ''
    }) => (
      <Field name="title" subscription={{ touched: true, error: true }} validate={isRequired}>
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            inputId="title"
            title={personDetailsTitleHeader}
            validationMessage={touched && !!error ? globalRadioError : ''}
          >
            <GenericRadio.StackedSet
              groupName="title"
              items={[
                {
                  id: personDetailsTitleValue1,
                  labelText: personDetailsTitleValue1
                },
                {
                  id: personDetailsTitleValue2,
                  labelText: personDetailsTitleValue2
                },
                {
                  id: personDetailsTitleValue3,
                  labelText: personDetailsTitleValue3
                },
                {
                  id: personDetailsTitleValue4,
                  labelText: personDetailsTitleValue4
                }
              ]}
              selectedId={values.title}
              {...input}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default Title;
